import React, { useCallback, useEffect, useRef, useState } from 'react'
import InputTextField from '../../../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { ButtonBack, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import TableCustom from '../../../../../components/table/tableCustom';
import { setLoading, unsetLoading } from '../../../../../store/loading/loading.slice';
import TableRowCommon from '../../../../../components/table/TableRowCommon';
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom';
import { alertActive, swalError, swalSuccess } from '../../../../../components/alert/swal';
import { dateTimeToView, dateToView } from '../../../../../utils/date.utils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { OnlineCourseApi } from '../../../../../api/cms-online-course/online_course.api';
import ModalCustom from '../../../../../components/modal/ModalCustom';
import FilterSelect from '../../../../../components/select/filterSelect';
import { MenuItem, Typography } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';

const defaultState = {
    id_online_course_file_document: 0,
    id_online_course_study_topics: undefined,
}
export default function Document({ view }: any) {
    const { id } = useParams();
    const fileRef = useRef<any>()

    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [open, setOpen] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const [listLesson, setListLesson] = useState<any[]>([]);
    const [listLessonTopic, setListLessonTopic] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: 'ลำดับ'
        },
        {
            id: "leave_type_name",
            width: '280px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อไฟล์"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '150px',
            sortable: false,
            align: "center",
            label: t("ขนาด"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '150px',
            sortable: false,
            align: "center",
            label: t("สกุลไฟล์"),
        },
        // {
        //     id: "user_updated",
        //     disablePadding: false,
        //     align: "center",
        //     width: '200px',
        //     label: t("ภายใต้หัวข้อการเรียน"),
        // },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '120px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_online_course_file,
            file_name,
            file_size,
            file_type,
            online_course_study_topics_name,
            modifier_name,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_online_course_file,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: file_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        formatBytes(file_size) || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        file_type || '-'
                    ),
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: (
                //         online_course_study_topics_name || '-'
                //     ),
                // },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit={!view}
                            enableDelete={!view}
                            onViewClick={() => {
                                setOpen(true)
                                setType('VIEW')
                                getDetailFile(id_online_course_file)
                                // setForm({ ...objData, id_online_course_file_document: objData.id_online_course_file, online_course_file_document: objData })
                            }}

                            onEditClick={() => {
                                setOpen(true)
                                setType('EDIT')
                                getDetailFile(id_online_course_file)
                                // setForm({ ...objData, id_online_course_file_document: objData.id_online_course_file, online_course_file_document: objData })
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_online_course_file)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await OnlineCourseApi.listFile(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const getDetailFile = async (idFile: any) => {

        const res = await OnlineCourseApi.getFileById(id, idFile);
        const data = res.data
        if (res.status < 300) {
            
            setForm({ ...data.data, id_online_course_file_document: data.data.id_online_course_file, online_course_file_document: data.data })
        }
    }

    const listLessonData = async () => {

        try {
            const res = await OnlineCourseApi.listLesson(id);
            const data = res.data
            if (data?.status < 300) {
                setListLesson(data?.data);

            } else {
            }
        } catch (error) {
        }
    }
    const listLessonTopicData = async (id_online_course_lesson: any) => {

        try {
            const res = await OnlineCourseApi.listLessonTopic(id, id_online_course_lesson);
            const data = res.data
            if (data?.status < 300) {
                setListLessonTopic(data?.data);

            } else {
            }
        } catch (error) {
        }
    }
    useEffect(() => {
        listLessonData()
    }, [])
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
    }
    const handleCreate = async () => {
        const body = {
            id_online_course_study_topics: form?.id_online_course_study_topics,
            id_online_course_file_document: form?.id_online_course_file_document,
        };
        if (type === 'EDIT') {
            await OnlineCourseApi.patchFile(body, id, form.id_online_course_file).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('บันทึกไฟล์ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await OnlineCourseApi.postFile(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มไฟล์ เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }

    const handleDelete = async (id_file: any) => {
        await OnlineCourseApi.deleteFile(id, id_file).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเรียบร้อย'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })


    }
    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);

            await OnlineCourseApi.fileDocument(formData).then((res: any) => {
                if (res.status < 300) {
                    setForm({ ...form, id_online_course_file_document: res.data.data.id_online_course_file, online_course_file_document: res.data.data })
                    console.log(res.data);

                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <div>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    {!view && <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.OnlineCourseManagementCreate);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("เพิ่มไฟล์")}
                    />}
                </article>
            </div>
            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t('เพิ่มไฟล์') : t('ข้อมูลไฟล์')} subTitle={t('กรุณาระบุรายละเอียด')} open={open} component={
                <div className='flex flex-col gap-4'>


                    <div className='col-span-12 md:col-span-12  border-2 rounded-lg border-[#DDE1EB] relative h-auto my-[20px]'>
                        <div className="flex items-center gap-4 p-[10px] ">
                            {type !== 'VIEW' && <AddBoxIcon sx={{ color: '#0F9F0C', cursor: 'pointer' }} onClick={() => fileRef.current.click()} />}
                            <input ref={fileRef} className='hidden' type='file'
                                // accept={"image/*"} 
                                onChange={(e: any) => onImageChange(e)} />

                            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>เลือกไฟล์</Typography>


                        </div>
                        {form?.online_course_file_document &&
                            <div className='flex items-center justify-between p-[20px]'>
                                <div>
                                    <Typography>{form?.online_course_file_document?.file_name}</Typography>
                                    <Typography>{formatBytes(form?.online_course_file_document?.file_size)} {form?.online_course_file_document?.created_date ? dateToView(form?.online_course_file_document?.created_date) : '-'}</Typography>

                                </div>
                                <OptionsButtonCustom
                                    enableView
                                    enableDelete={type !== 'VIEW'}
                                    onViewClick={() => {
                                        window.open(process.env.REACT_APP_FILE_BASE_API + '/' + form?.online_course_file_document?.file_path + form?.online_course_file_document?.file_name, '_blank');

                                    }}


                                    onDeleteClick={() => {
                                        setForm({ ...form, id_online_course_file_document: undefined, online_course_file_document: undefined })

                                    }} />
                            </div>}
                    </div>
                    {/* <div>
                        <FilterSelect
                            value={form?.id_online_course_lesson || ""}
                            heading={t('อยู่ภายใต้บทเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLesson.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_lesson} key={index + 1}>
                                    {item.online_course_lesson_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                listLessonTopicData(e.target.value)
                                setForm({ ...form, id_online_course_lesson: e.target.value })
                            }}
                            disabled={false}
                        />
                    </div>
                    <div>
                        <FilterSelect
                            value={form?.id_online_course_study_topics || ""}
                            heading={t('ภายใต้หัวข้อการเรียน')}
                            labelId="year-id"
                            selectId="year-select-id"
                            options={listLessonTopic.map((item: any, index: number) => (
                                <MenuItem value={item.id_online_course_study_topics} key={index + 1}>
                                    {item.online_course_study_topics_name}
                                </MenuItem>
                            ))}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, id_online_course_study_topics: e.target.value })
                            }}
                            disabled={!form?.id_online_course_lesson}
                        />
                    </div> */}

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
